<subscription-page
  [subscription]="subscription()"
  [reportedStatus]="reportedStatus()"
  [isLoading]="isLoading()"
  [isNotFound]="isNotFound()"
  [isNotAuthorized]="isNotAuthorized()"
>
  @if (subscription(); as sub) {
    <lightpath-subscription-view
      [subscription]="sub"
      [activities]="activities()"
      [activeTab]="activeTab()"
      (selfServiceOpen)="openSelfServiceDialog($event)"
    />
  }
</subscription-page>
